/* eslint-disable max-len */
import axios, { STRAPI_URL } from '@propertypal/shared/src/services/axios.strapi';
import { IFaqSubSection } from '@propertypal/shared/src/types/strapi';
import { StrapiResponse } from '@propertypal/shared/src/types/strapi/generic';
import platform from '@propertypal/shared/src/utils/platform';
import FaqPageContainer from '@propertypal/web-ui/src/faq/FaqPageContainer';
import FaqSectionGrid from '@propertypal/web-ui/src/faq/FaqSectionGrid';
import { GetStaticProps } from 'next';
import Head from 'next/head';
import React, { FunctionComponent } from 'react';
import generateMetaTags from '../../components/layout/MetaTags';

interface FaqProps {
  data: IFaqSubSection[] | null;
}

const metaData = {
  title: `Frequently Asked Questions - ${platform.title}`,
  description: `${platform.title} FAQs. View A List Of Frequently Asked Questions & Answers About Our Website & Services.`,
  url: `/faq`,
};

export const getStaticProps: GetStaticProps<FaqProps> = async () => {
  const platformFilter: Record<string, string> = {
    'filters[$or][0][platform][$eq]': platform.title === 'Propertynews' ? 'Propertynews' : 'PropertyPal',
    'filters[$or][1][platform][$eq]': 'Both',
  };

  if (platform.title === 'PropertyPal') platformFilter['filters[$or][2][platform][$null]'] = 'true';

  // get all Website User FAQ section sub sections
  const result = await axios<StrapiResponse<IFaqSubSection[]>>({
    method: 'GET',
    url: `${STRAPI_URL}/faq-sub-sections`,
    params: {
      populate: 'deep,3',
      // only get sub sections with a section with id from slug
      'filters[faqSection][$eqi]': 'Website User FAQ',
      ...platformFilter,
      'sort[0]': 'subSection:asc',
      'sort[1]': 'publishedAt:desc',
    },
  });

  return {
    props: {
      data: result.data.data,
      disableHeader: true,
      disableFooter: true,
    },
  };
};

const Faq: FunctionComponent<FaqProps> = ({ data }) => {
  return (
    <>
      <Head>{generateMetaTags(metaData)}</Head>

      <FaqPageContainer base>
        <FaqSectionGrid data={data} />
      </FaqPageContainer>
    </>
  );
};

export default Faq;
